import { combineReducers } from 'redux';
import propOr from 'ramda/src/propOr';
import propEq from 'ramda/src/propEq';
import pathOr from 'ramda/src/pathOr';
import find from 'ramda/src/find';
import pipe from 'ramda/src/pipe';
import juxt from 'ramda/src/juxt';
import join from 'ramda/src/join';
import reject from 'ramda/src/reject';
import isEmpty from 'ramda/src/isEmpty';
import filter from 'lodash/fp/filter';
import { createSelector } from 'reselect';

import { fullName } from '../../../common/helpers/users';
import coupons from './coupons';
import hourlyWageRules from './hourlyWageRules';
import byId from './byId';
import list, * as fromList from './list';
import loan from './loan';
import * as barbers from '../../../main/barbers/selector';
import { getSearchResults } from '../../../main/search/selectors';

const shops = combineReducers({
  byId,
  list,
  loan,
  coupons,
  hourlyWageRules,
});

export default shops;

export const getShop = (state, id) => pathOr({}, ['admin', 'shops', 'byId', id], state);
export const getShops = state => fromList.getIds(state.admin.shops.list);

export const getEnabledShops = pipe(
  getShops,
  filter({ enabled: true }),
);

export const getDisabledShops = pipe(
  getShops,
  filter({ enabled: false }),
);

export const getShopBarbers = (state, shopId) => {
  const shop = getShop(state, shopId);
  if (!shop) {
    return [];
  }
  return barbers.getByIds(state, shop.barbers);
};

const extractShopName = pathOr('N/A', ['shops', 0, 'name']);
export const getAllBarbersForUserForm = createSelector(
  getSearchResults,
  searchResults => searchResults.map(result => ({
    id: result.document.id,
    name: result.document.name,
    shop: extractShopName(result.document),
  }))
);

const getName = propOr('', 'name');
export const getShopName = (state, shopId) => getName(getShop(state, shopId));
export const getBarber = (state, shopId, barberId) => find(propEq('id', barberId), getShopBarbers(state, shopId));
const getBarberName = (state, shopId, barberId) => fullName(getBarber(state, shopId, barberId));

export const getSettingsTitle = pipe(
  juxt([getShopName, getBarberName]),
  reject(isEmpty),
  join(' - ')
);

const rejectNonCommissionSplitShops = reject(shop => !shop.commissionSplits);

export const getCommissionSplitShops = createSelector(
  getShops,
  rejectNonCommissionSplitShops,
);

const rejectNonDailyPayrollShops = reject(shop => !shop.dailyPayroll);

export const getDailyPayrollShops = createSelector(
  getShops,
  rejectNonDailyPayrollShops,
);

export const getHourlyWageRules = state => state.admin.shops.hourlyWageRules;
